import * as React from "react";

function SvgInspectlet(props, ref) {
  return (
    <svg
      data-name="Layer 1"
      viewBox="0 0 64 64"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#dadcec"
        d="M40.172 44l3.918-3.917 2.828 2.829-3.917 3.917z"
      />
      <rect
        width={8.49}
        height={22.51}
        x={48.8}
        y={41.79}
        fill="#cda1a7"
        rx={4}
        ry={4}
        transform="rotate(-45 53.04 53.04)"
      />
      <rect
        width={4.24}
        height={22.51}
        x={49.42}
        y={43.29}
        fill="#c4939c"
        rx={2.12}
        ry={2.12}
        transform="rotate(-45 51.542 54.54)"
      />
      <path fill="#ffeb9b" d="M25 1a24 24 0 100 48 24 24 0 100-48z" />
      <path
        fill="#f6d397"
        d="M11.14 38.86l27.72-27.72a4 4 0 016.11.54A24 24 0 0111.68 45a4 4 0 01-.54-6.14z"
      />
      <path fill="#bbdef9" d="M25 7a18 18 0 100 36 18 18 0 100-36z" />
      <path fill="#d2edff" d="M25 18a7 7 0 100 14 7 7 0 100-14z" />
      <path
        fill="#f3f3f3"
        d="M21 17a4 4 0 100 8 4 4 0 100-8zm8.5 11a1.5 1.5 0 100 3 1.5 1.5 0 100-3z"
      />
      <path
        fill="#8d6c9f"
        d="M38.44 11.57a19 19 0 100 26.87 18.88 18.88 0 000-26.87zM37 37a17 17 0 110-24 16.89 16.89 0 010 24z"
      />
      <path
        fill="#8d6c9f"
        d="M31.2 14.72a12 12 0 012.28 1.79 1 1 0 101.42-1.41 14.08 14.08 0 00-2.67-2.1 1 1 0 00-1 1.71zm-4.82-3.65a14 14 0 00-11.27 4 1 1 0 101.41 1.41 12 12 0 019.67-3.46 1 1 0 10.2-2z"
      />
      <path
        fill="#8d6c9f"
        d="M61.88 54.46L51.54 44.12a5 5 0 00-3.6-1.45c0-.14-2.77-2.91-2.77-2.91a25 25 0 10-5.41 5.41s2.78 2.72 2.91 2.77 0 0 0 .07a5 5 0 001.46 3.54l10.33 10.33a5 5 0 007.07 0l.34-.34a5 5 0 000-7.07zM2 25a23 23 0 1123 23A23 23 0 012 25zm42.12 19.46a5 5 0 00-.92 1.32l-1.87-1.87a25.2 25.2 0 002.59-2.59l1.88 1.88a5 5 0 00-1.32.92zm16.34 15.66l-.34.34a3 3 0 01-4.24 0L45.54 50.12a3 3 0 010-4.24l.34-.34a3 3 0 014.24 0l10.34 10.34a3 3 0 010 4.24z"
      />
      <path
        fill="#8d6c9f"
        d="M34.19 32.78a1 1 0 00-1.41 1.41l1.41 1.41a1 1 0 001.41-1.41zm-18.38 0l-1.41 1.41a1 1 0 101.41 1.41l1.41-1.41a1 1 0 00-1.41-1.41zM39 24h-2a1 1 0 000 2h2a1 1 0 000-2zm-25 1a1 1 0 00-1-1h-2a1 1 0 000 2h2a1 1 0 001-1zm11 11a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm13.28-6.45l-1.84-.78a1 1 0 10-.78 1.84l1.84.78a1 1 0 10.78-1.84zM20.7 35.13a1 1 0 00-1.31.53l-.78 1.84a1 1 0 101.84.78l.78-1.84a1 1 0 00-.53-1.31zm-5.9-6.01a1 1 0 00-1.3-.55l-1.85.75a1 1 0 10.75 1.85l1.85-.75a1 1 0 00.55-1.3zm15.62 6.63a1 1 0 00-1.85.75l.75 1.85a1 1 0 001.85-.75z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgInspectlet);
